import { Component, OnInit, Inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatPaginator } from '@angular/material';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { Messages } from '../constants/messages';
import { ValidationService } from '../validation.service';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, filter } from 'rxjs/operators';

export interface attachVehicleData {
  driver_id: string,
  vehicle_id: string
}
@Component({
  selector: 'app-attach-vehicle',
  templateUrl: './attach-vehicle.component.html',
  styleUrls: ['./attach-vehicle.component.scss']
})
export class AttachVehicleComponent implements OnInit {
  columnsToDisplay = ['vehicleType', 'number', 'regYear', 'action'];
  vehicles = [];
  attachVehicle: attachVehicleData = {
    driver_id: '',
    vehicle_id: ''
  };
  allVehicles = [];
  vehicleFilters: any = {};
  filters: any = {
    vehicleType: [],
    vehicleNumber: '',
  };
  showLoader = false;
  subscription: Subscription;
  searchTextChanged = new Subject<object>();
  errors = new Messages();
  totalVehicles = 0;
  // vehiclesFilter: any = {};
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  constructor(private http: HttpService, private translation:TranslateService,private snackbar: SnackbarService, @Inject(MAT_DIALOG_DATA) private parentData: any,
  private changeDetection: ChangeDetectorRef,private dialog: MatDialogRef<AttachVehicleComponent>, private valid: ValidationService, private dailogOpen: MatDialog) { }

  ngOnInit() {
    console.log(this.parentData)
    this.getVehicleTypes();
    this.getVehicles();
  }

  getVehicles(filter: any = {}) {
    this.showLoader = true;
    filter.limit = this.paginator.pageSize || 10;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    this.http.post('vehicle/many', filter).subscribe(
      (data: any) => {
        this.showLoader = false;
        if (data.statusCode === 200) {
          this.vehicles = [];
          const result = data.data.vehicles;
          this.totalVehicles = data.data.count;
          result.forEach(element => {
            const temp: any = {};
            temp._id = element._id;
            temp.vehicleType = element.type.name;
            temp.number = element.REG_number;
            temp.bodyType = element.type.body_type;
            temp.regYear = (element.registration)? element.registration.year : '--';
            temp.attached = (element.attached_driver) ? element.attached_driver : '';
            temp.action = '';
            this.vehicles.push(temp);
          });
          this.paginator._intl.itemsPerPageLabel= this.translation.instant('ATTACHVEHICLE.pagination_label');
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.paginator._intl.itemsPerPageLabel= this.translation.instant('ATTACHVEHICLE.pagination_label');
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }
  pageNavigate(event) {
    this.vehicleFilters.limit = event.pageSize;
    this.vehicleFilters.skip = event.pageIndex * event.pageSize;
    this.getVehicles(this.vehicleFilters);
  }

  attach(row) {
    this.attachVehicle.vehicle_id = row._id;
    this.attachVehicle.driver_id = this.parentData._id;
    const dialogData = {
      name: 'Attach Vehicle',
      text: this.errors.ATTACHVEHICLE.DIALOGDATA.OVERWRITE,
      driver_id: this.parentData._id,
      vehicle_id: row._id,
      url: 'driver/attach'
    }
    if (row.attached.length) {

      const dialogRef = this.dailogOpen.open(ConfirmationModalComponent, {
        data: dialogData
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.statusCode == 200 || result == 'yes') {
          this.getVehicles();
          this.closeModal(result);
        }
      });
    } else {

      this.http.post('driver/attach', this.attachVehicle).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            this.snackbar.openSnackBar(this.errors.ATTACHVEHICLE.SUCCESS.ATTACHSUCCESSFULL,'');
            this.closeModal(data);
          }
        },
        (err: any) => {
          this.snackbar.openSnackBar(err.error.message,'', 'err');
            if (err.error.statusCode == 401) {
              this.valid.logout();
            }
        }
      );
    }
  }
  searchFilter(value, type) {
    this.changeDetection.detectChanges();
    if (type!='type' && value.length) {
      switch (type) {
        case 'number':
          this.vehicleFilters.number = value;
          break;
      }
      this.reSubscribe();
      this.searchTextChanged.next(this.vehicleFilters);
    } else if (type=='type' && value.length) {
      this.vehicleFilters.types = value;
      this.reSubscribe();
      this.searchTextChanged.next(this.vehicleFilters);
    }else{
      this.clearFilter(type);
    }
  }

  reSubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this.searchTextChanged.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      map(search => search)
    ).subscribe((x) => {
      this.removeFocus();
      this.getVehicles(x); });
    this.changeDetection.detectChanges();
  }

  removeFocus() {
    const inputs: any = [].slice.call(document.getElementsByTagName('input'));
    inputs.forEach((element: HTMLElement) => {
      element.blur();
    });
  }

  clearFilter(type) {
    switch (type) {
      case 'type':
        delete this.vehicleFilters.types;
        break;
      case 'number':
        delete this.vehicleFilters.number;
        break;
    }
    this.getVehicles(this.vehicleFilters);
  }

  getVehicleTypes() {
    this.http.get('carrier_pref').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {

          if (data.data.vehicle_types.length) {
            this.allVehicles = data.data.vehicle_types;
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  selectVehicleType(vehicle, event) {
    if (event.source._selected) {
      if (this.filters.vehicleType.indexOf(vehicle._id) == -1) {
        this.filters.vehicleType.push(vehicle._id);
      }
    } else if (!event.source._selected) {
      if (this.filters.vehicleType.indexOf(vehicle._id) > -1) {
        this.filters.vehicleType.splice(this.filters.vehicleType.indexOf(vehicle._id), 1);
      }
    }
  }
  closeModal(data) {
    this.dialog.close(data);
  }
  closeDialog() {
    this.dialog.close();
  }
}
